import {
  EDIT_PROFILE_REQUEST,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  VERIFY_TOKEN_REQUEST,
  VERIFY_TOKEN_SUCCESS,
  VERIFY_TOKEN_FAILURE,
  CLEAR_PROFILE_MESSAGES
} from '../constants/profileConstants';

// Edit Profile Actions
export const editProfileRequest = (profileData) => ({
  type: EDIT_PROFILE_REQUEST,
  payload: profileData
});

export const editProfileSuccess = (data) => ({
  type: EDIT_PROFILE_SUCCESS,
  payload: data
});

export const editProfileFailure = (error) => ({
  type: EDIT_PROFILE_FAILURE,
  payload: error
});

// Change Password Actions
export const changePasswordRequest = (passwordData) => ({
  type: CHANGE_PASSWORD_REQUEST,
  payload: passwordData
});

export const changePasswordSuccess = (data) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: data
});

export const changePasswordFailure = (error) => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload: error
});

// Verify Email Actions
export const verifyEmailRequest = (emailData) => ({
  type: VERIFY_EMAIL_REQUEST,
  payload: emailData
});

export const verifyEmailSuccess = (data) => ({
  type: VERIFY_EMAIL_SUCCESS,
  payload: data
});

export const verifyEmailFailure = (error) => ({
  type: VERIFY_EMAIL_FAILURE,
  payload: error
});

// Verify Token Actions
export const verifyTokenRequest = (token, email) => ({
  type: VERIFY_TOKEN_REQUEST,
  payload: { token, email }
});

export const verifyTokenSuccess = (data) => ({
  type: VERIFY_TOKEN_SUCCESS,
  payload: data
});

export const verifyTokenFailure = (error) => ({
  type: VERIFY_TOKEN_FAILURE,
  payload: error
});

// Clear Messages
export const clearProfileMessages = () => ({
  type: CLEAR_PROFILE_MESSAGES
});